import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import { media, padding, typography } from "../../styles";
import React, { useState } from "react";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
type CollapsibleSectionProps = React.PropsWithChildren<{
  className?: string;
  collapseDisabled?: boolean;
  headerContent?: React.ReactNode;
  open?: boolean;
  small?: boolean;
  title: string;
}>;
export function CollapsibleSection(props: CollapsibleSectionProps) {
  const {
    children,
    className,
    collapseDisabled,
    headerContent,
    open,
    small,
    title
  } = props;
  const [isOpen, setIsOpen] = useState<boolean>(open ?? false);
  const handleToggleOpen = () => {
    setIsOpen(!isOpen);
  };
  const iconProps: FontAwesomeIconProps & {
    small?: boolean;
  } = {
    icon: faChevronUp,
    size: small ? "1x" : "2x",
    title,
    ...(!isOpen && {
      rotation: 180
    })
  };
  return <div className={className} data-sentry-component="CollapsibleSection" data-sentry-source-file="CollapsibleSection.tsx">
      {collapseDisabled ? <Title small={small}>{headerContent ?? title}</Title> : <Button onClick={handleToggleOpen} small={small} type="button">
          <Title small={small}>{headerContent ?? title}</Title>
          <FontAwesomeIcon {...iconProps} />
        </Button>}
      {(isOpen || collapseDisabled) && children}
    </div>;
}
export default CollapsibleSection;
const Button = styled.button<{
  small?: boolean;
}>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  border: none;
  ${padding.zero}
  background: none;
  color: ${({
  small,
  theme
}) => small ? theme.brand.cssVars["--d-text"] : theme.brand.cssVars["--d-primary"]};

  @media ${media.hoverable} {
    &:hover {
      cursor: pointer;
    }
  }

  svg {
    color: ${({
  small,
  theme
}) => small ? theme.brand.cssVars["--d-muted"] : "inherit"};
  }
`;
const Title = styled.h2<{
  small?: boolean;
}>`
  color: ${({
  theme
}) => theme.brand.cssVars["--d-text"]};
  ${({
  small
}) => small ? typography.smallBold : typography.title}
`;